/* eslint-disable no-inner-declarations */
import 'maphilight';
import imageMapResize from 'image-map-resizer';
import tippy from 'tippy.js';
import 'select2';


let viewportWidth = document.documentElement.clientWidth;

$(document).ready(function () {
  if ($('img[usemap]').length) {

    // Init mapHilight
    // initMapHilight();

    // Adaptiv coords
    imageMapResize();

    // Init MapHilight for change tab
    $('.tabs__btn').on('click', function () {
      imageMapResize();
      // initMapHilight();
    });

    // initMapHilight();

    // function initMapHilight() {
    //   $('img[usemap]').maphilight({
    //     alwaysOn: true,
    //     fill: true,
    //     fillOpacity: '1',
    //     shadow: 0,
    //     stroke: false
    //   });
    // }

    $(window).resize(function () {
      // initMapHilight();
      imageMapResize();
      initTooltip();
      viewportWidth = document.documentElement.clientWidth;
      initTooltip();
    });

    // Animation.register(keys_map);
    Animation.info_icons();
  }

  initTooltip();


  var selectMap = $('.js-select-map').select2({
    minimumResultsForSearch: Infinity,
    templateResult: formatDrop,
    templateSelection: formatDrop
  });

  // Custom drop link select
  function formatDrop(state) {
    var bg = $(state.element).data('bg');

    var stateLink = $(
      '<span class="elem-select__map-drop" style="background-color:' + bg + '">' + state.text + ' ' + '</span>'
    );
    return stateLink;
  }

  // For change area in map
  selectMap.on('select2:select', function () {
    console.log(this.value);
  });


});

var Animation = {
  register: function (ids) {
    $(ids).each(function (index, value) {
      let $this = $(`area[data-key=${value}]`);
      let data = {};
      data.fillColor = $this.data('fill').slice(1);

      $this.data('maphilight', data).trigger('alwaysOn.maphilight');
    });

    $('.btn-tag').on('click', function () {
      let $this = $(this);
      let key = $this.data('key');
      let data = {};
      data.fillColor = $(this).data('fill').slice(1);

      if ($this.hasClass('active')) {
        $this.removeClass('active');
        $(`area[data-key=${key}]`).data('maphilight', data).trigger('alwaysOn.maphilight');
      } else {
        $this.addClass('active');
        data.stroke = true;
        data.strokeColor = '000000';
        data.strokeOpacity = 1;
        data.strokeWidth = 0.7;
        data.shadow = 1;
        data.shadowX = 3;
        data.shadowY = 3;
        data.shadowRadius = 6;
        data.shadowColor = '000000';
        data.shadowOpacity = 0.4;
        data.shadowPosition = 'outside';
        data.shadowFrom = 'fill';
        $(`area[data-key=${key}]`).data('maphilight', data).trigger('alwaysOn.maphilight');
      }
    });
  },
  info_icons: function () {
    // var is_set = false;

    $('.icon-group').hover(
      function () {
        $(`page-complex-map__icons-item[data-key=${$(this).data('key ')}`).addClass('active ');

        $('.icon-group').hide();
        $('.icon-group-' + $(this).data('key')).show();
      },
      function () {
        $('.map-icon').removeClass('active');
        $('.icon-group').show();
      }
    );

    $('.map-icon').hover(
      function () {
        $('.icon-group-' + $(this).data('key')).first().mouseover();
      },
      function () {
        $('.icon-group-' + $(this).data('key')).first().mouseleave();
      }
    );
  }
};

function initTooltip() {
  if (viewportWidth < 1024) {
    tippy('.js-tooltip-icon', {
      animation: 'scale',
      arrow: true,
      arrowType: 'sharp'
    });
  }
}